module.exports = __webpack_public_path__ + "img/goods-hk.ef9a7f7c.png";